import { request } from 'tools'

export const getTodos = params => request.get( 'todo/tasks', params )
